// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2Oi_F","insightsList":"newBusinessInsightsMenu_insightsList__2b01x","active":"newBusinessInsightsMenu_active__p2Y2Q"};